"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

/**
 * PATH - in the API can be in one of the following forms:
 * A storage service path. Example: cloud-content/56475bf9-dd79-401b-8978-9b88780bae41.xdc
 * A storage service id-based path. Example: id/urn:aaid:sc:US:2f86d5e2-0fd2-49b8-a05e-6a47cd056486
 * A full storage service path-based URL. Example: https://cc-api-storage-stage.adobe.io/cloud-content/56475bf9-dd79-401b-8978-9b88780bae41.xdc
 * A full storage service id-based URL. Example: https://cc-api-storage-stage.adobe.io/id/urn:aaid:sc:US:05286244-1eae-4e51-89a9-9ac99d6647f5
 */

/**
 * Share endpoint for api version three.
 */
var AccessRequestsService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(AccessRequestsService, _DAO);

  var _super = _createSuper(AccessRequestsService);

  function AccessRequestsService() {
    (0, _classCallCheck2["default"])(this, AccessRequestsService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AccessRequestsService, [{
    key: "_createUrl",

    /**
    * Helper method to create the share api url
    * @param {String} resourceUrl 
    */
    value: function _createUrl(resourceUrn) {
      return this.apiVersion.toLowerCase() === 'v4' ? "".concat(this._endpoint, "/accessrequests/").concat(resourceUrn) : "".concat(this._endpoint, "/accessrequests");
    }
    /**
    * get - get sharing information for a resource
    * @param {Object} request
    *   @property {String} orderBy (required) - Supported values
    *             +requesttime: ascending by request create date
    *             -requesttime: descending by request create date
    *   @property {Number} limit (optional, default: 10, max: 30) - integer, maximum number of requests to return
    *   @property {String} type (optional, default:) - Comma Separated List, types of resource to return. If omitted, all types are returned
    *   @property {String} resourceUrn (optional,default) - if set to resourceUrn api returns access requests on a particular resource 
    * @returns {Promise}
    */

  }, {
    key: "get",
    value: function get(request) {
      var _request$orderBy = request.orderBy,
          orderBy = _request$orderBy === void 0 ? '-requesttime' : _request$orderBy,
          _request$types = request.types,
          types = _request$types === void 0 ? [] : _request$types,
          _request$limit = request.limit,
          limit = _request$limit === void 0 ? 10 : _request$limit,
          resourceUrn = request.resourceUrn;
      var params = {
        limit: limit,
        orderBy: orderBy,
        resourceUrn: undefined,
        types: types
      };

      var url = this._createUrl(resourceUrn); // ADD FOR V3 resourceUrn


      if (this.apiVersion.toUpperCase() === 'V3') {
        params.resourceUrn = resourceUrn;
      }

      return this.getRequest({
        params: params,
        url: url
      });
    }
    /**
      * Get the next page of AccessRequests results, using the URL from AccessRequests.get().
      * @param url {String} URL from AccessRequests.get(), from the _links.next property of the response.
      * @returns {Promise|*|Promise<Response>}
      */

  }, {
    key: "getNextPage",
    value: function getNextPage(url) {
      return this.getRequest({
        url: url
      });
    }
    /**
     * Request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *   @property {String} resourceUrn - (required) URN of the resource to request access.
     *   @property {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *   @property {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *   @property {String} targetUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *             If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *   @property {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *             The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "request",
    value: function request(options) {
      var _options$locale = options.locale,
          locale = _options$locale === void 0 ? 'EN_US' : _options$locale,
          message = options.message,
          resourceUrn = options.resourceUrn,
          targetUrl = options.targetUrl,
          templateName = options.templateName;

      if (resourceUrn && templateName) {
        var notification = {
          email: {
            locale: locale,
            templateName: templateName
          },
          parameters: {
            message: message,
            targetUrl: targetUrl
          }
        };
        var params = {
          notification: notification,
          resourceUrn: resourceUrn
        };
        var url = "".concat(this._endpoint, "/accessrequests");
        return this.postRequest({
          params: params,
          url: url
        });
      }

      throw new Error('Access Requests create failed.');
    }
    /**
     * Respond to request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *   @property {String} resourceUrn - (required) URN of the requested resource.
     *   @property {String} requesterId - (required) userID of the requester.
     *   @property {String} role - (required when action is 'grant').
     *   @property {String} action - (required) Either 'grant' or 'reject'.
     *   @property {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *   @property {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *   @property {String} targetUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *             If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *   @property {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *             The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "respond",
    value: function respond() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = options.action,
          canComment = options.canComment,
          canShare = options.canShare,
          _options$locale2 = options.locale,
          locale = _options$locale2 === void 0 ? 'EN_US' : _options$locale2,
          message = options.message,
          requesterId = options.requesterId,
          targetUrl = options.targetUrl,
          resourceUrn = options.resourceUrn,
          role = options.role,
          templateName = options.templateName,
          useMounts = options.useMounts;

      if (resourceUrn && requesterId && action && templateName) {
        if (action === 'grant' && role || action === 'reject') {
          var notification = {
            email: {
              templateName: templateName,
              locale: locale
            },
            parameters: {
              targetUrl: targetUrl,
              message: message
            }
          };
          var params = {
            action: action,
            role: role,
            requesterId: requesterId,
            resourceUrn: resourceUrn,
            notification: notification,
            useMounts: useMounts
          };
          var url = "".concat(this._endpoint, "/accessrequests/ops");

          if (action === 'grant') {
            var paramsWithPermissions = _objectSpread(_objectSpread({}, params), {}, {
              canComment: canComment,
              canShare: canShare
            });

            return this.postRequest({
              params: paramsWithPermissions,
              url: url
            });
          }

          return this.postRequest({
            params: params,
            url: url
          });
        }
      }

      throw new Error('accessrequests.respond failed');
    }
    /**
     * Grant request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *   @property {String} resourceUrn - (required) URN of the requested resource.
     *   @property {String} requesterId - (required) userID of the requester.
     *   @property {String} role - (required).
     *   @property {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *   @property {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *   @property {String} requestViewUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *             If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *   @property {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *             The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "grant",
    value: function grant(options) {
      var request = _objectSpread(_objectSpread({}, options), {}, {
        action: 'grant'
      });

      return this.respond(request);
    }
    /**
     * Reject request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *   @property {String} resourceUrn - (required) URN of the requested resource.
     *   @property {String} requesterId - (required) userID of the requester.
     *   @property {String} role - (required).
     *   @property {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *   @property {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *   @property {String} requestViewUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *             If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *   @property {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *             The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "reject",
    value: function reject(options) {
      var request = _objectSpread(_objectSpread({}, options), {}, {
        action: 'reject'
      });

      return this.respond(request);
    }
  }]);
  return AccessRequestsService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(AccessRequestsService, InstanceConfig);

exports["default"] = _default;